import {TreeSelectWithoutContainer} from "../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../assets/functions";
import {getDiscountCodeAmountDescription, getDiscountCodeByCustomerId} from "../../DiscountCode/functions";
import {TextInputWithoutContainer} from "../../../component/TextInput/TextInput";
import {SelectWithoutContainer} from "../../../component/Select/Select";
import {
    getAllSingleProductsOfProductObject,
    getSingleProductsOfPrices,
    printInstallmentConditions
} from "../../Products/functions";
import {PickDateTimeWithoutContainer} from "../../../component/PickDate/PickDate";
import {Fragment, useEffect, useState} from "react";
import {
    getBillAmountWithoutDiscount, getBillDiscountAmount, getBillPayableAmount, getBillPayedAmount, getPayableAmount,
    getProductWithSingleProduct,
    getSingleProductPersianTitleById,
    getUnitPrice,
    printUnitPriceForBill
} from "../functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import {getAllCustomersObject} from "../../Customers/functions";
import {getAllCurrenciesObject} from "../../Currencies/functions";
import {getCustomerAddressesObjectById} from "../../../component/AddressForm/functions";
import Loading from "../../../component/Loading/Loading";

const OrderForm = ({bill, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);

    const payTypeOptions = [
        {
            label: "نقدی",
            value: "CASH",
        }, {
            label: "اقساط",
            value: "INSTALLMENT",
        },
    ];
    const refundMethodOptions = [
        {
            label: "هفتگی",
            value: "WEEKLY",
            days: 7,
        }, {
            label: "ماهانه",
            value: "MONTHLY",
            days: 30,
        }, {
            label: "هر دو ماه",
            value: "EVERY_TWO_MONTH",
            days: 60,
        }, {
            label: "هر سه ماه",
            value: "EVERY_THREE_MONTH",
            days: 90,
        }, {
            label: "هر چهار ماه",
            value: "EVERY_FOUR_MONTH",
            days: 120,
        }, {
            label: "هر شش ماه",
            value: "EVERY_SIX_MONTH",
            days: 180,
        }, {
            label: "سالانه",
            value: "YEARLY",
            days: 365,
        },
    ];
    const statusOptions = [
        {
            label: "وصول نشده",
            value: "INSERT",
        }, {
            label: "حذف کردن",
            value: "DISABLED",
        }, {
            label: "وصول شد",
            value: "PAYED",
        },
    ];
    const userLevels = [
        {
            persianLabel: "عادی",
            englishLabel: "normal",
        }, {
            persianLabel: "نقره ای",
            englishLabel: "silver",
        }, {
            persianLabel: "طلایی",
            englishLabel: "gold",
        },
    ];

    const deliveryOptions = [
        {
            label: "منتظر بررسی",
            value: "WAITING",
        }, {
            label: "تایید شده",
            value: "VERIFIED",
        }, {
            label: "ارسال شده",
            value: "SENDING",
        }, {
            label: "تحویل داده شده",
            value: "DELIVERED",
        },{
            label: "عودت داده شده",
            value: "RETURNED",
        }
    ];

    const [allProducts, setAllProducts] = useState([]);
    const [allSingleProducts, setAllSingleProducts] = useState([]);
    const [singleProductPrices, setSingleProductPrices] = useState({});
    const [allCurrencyObject, setAllCurrencyObject] = useState([]);
    const [allCustomersObject, setAllCustomersObject] = useState([]);
    const [allCustomerAddresses, setAllCustomerAddresses] = useState([]);
    const [customerDiscountCodes, setCustomerDiscountCodes] = useState([]);

    const installmentHistory = {
        amount: "",
        paymentTimestamp: "",
        payedTimestamp: "",
        description: "",
        privateDescription: "",
        status: "INSERT",
    };


    const billItem = {
        singleProductId: "",
        count: "",
        payType: "CASH",
        priceRate: "",
        prepayedAmount: "",
        numberOfInstallment: "",
        refundMethod: "MONTHLY",
        priceId: "",
        price: {
            currency: {
                id: 1,
                name: "تومان",
                rate: 1
            },
            amount: "",
            discountAmount: "",
            discountPercent: "",
            isClosed: "",
            closedRate: "",
            minimumRate: ""
        },
        installmentHistories: [],
        isPayed: true,
        deliveryStatus: "WAITING",

    };
    const [tempValues, setTempValues] = useState({
        productId: "",
        manualPrice: false,
        showDefinedInstallment: false,
        billItem: {...billItem}
    })

    useEffect(() => {
        (async () => {
            const allCustomersObject = await getAllCustomersObject();
            setAllCustomersObject(allCustomersObject);
            const allProducts = await getProductWithSingleProduct("?length=ALL");
            setAllProducts(allProducts);
            setAllCurrencyObject(await getAllCurrenciesObject());
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (bill.customerId) {
                const addresses = await getCustomerAddressesObjectById(bill.customerId);
                setAllCustomerAddresses(addresses);

                const discountCodes = await getDiscountCodeByCustomerId(bill.customerId);
                if (bill.discountCode){
                    const i = discountCodes.findIndex(d => d.id === bill.discountCode.id);
                    if (i < 0) {
                        if (!discountCodes.includes(bill.discountCode)){
                            discountCodes.push(bill.discountCode);
                        }
                    }

                }

                setCustomerDiscountCodes(discountCodes);

            } else {
                setAllCustomerAddresses([])
                setCustomerDiscountCodes([]);

            }
        })();

    }, [bill.customerId]);

    useEffect(() => {
        (async () => {
            if (tempValues.productId) {
                const singleProducts = await getAllSingleProductsOfProductObject(tempValues.productId);
                setAllSingleProducts(singleProducts);
            } else {
                setAllSingleProducts([]);
                setSingleProductPrices({});
            }
        })();

    }, [tempValues.productId]);

    useEffect(() => {
        (async () => {

            if (tempValues.billItem.singleProductId) {
                const singleProductsPrices = await getSingleProductsOfPrices(tempValues.billItem.singleProductId);
                setSingleProductPrices(singleProductsPrices);
            } else {
                setSingleProductPrices({});
            }
        })();

    }, [tempValues.billItem.singleProductId]);


    const getPaymentTimestampp = (refundMethod, number) => {
        let coefficient = 1;
        const currentTimestamp = Math.round(+new Date() / 1000);
        for (let i = 0; i < refundMethodOptions.length; i++) {
            if (refundMethodOptions[i].value == refundMethod) {
                coefficient = refundMethodOptions[i].days * number;
            }
        }
        if (coefficient == 1)
            return currentTimestamp

        return currentTimestamp + (60 * 60 * 24 * coefficient);
    }
    const getInstallmentHistory = (numberOfInstallment = 1, refundMethod) => {
        const newInstallmentHistories = [];
        for (let i = 0; i < numberOfInstallment; i++) {
            newInstallmentHistories.push({
                ...installmentHistory,
                paymentTimestamp: getPaymentTimestampp(refundMethod, i + 1)
            })
        }
        return newInstallmentHistories;
    }
    const changeBill = (key, value) => {
        const newBill = {...bill, [key]: value};
        if (key == "customerId" && value == "") {
            newBill.addressId = "";
            newBill.discountCodeId = "";
        }

        onChange(newBill);

    }
    const changeTempValues = (key, value) => {
        const newTempValues = {...tempValues, [key]: value};
        if (key == 'manualPrice' && value) {
            newTempValues.billItem.priceId = "";
        }

        setTempValues(newTempValues);
    }


    if (isLoading)
        return <Loading/>

    return (
        <div className="card">
            <div className="card-body">
                <div className="row">

                    <div className="col-12 mb-4">
                        <TreeSelectWithoutContainer label={"انتخاب مشتری"} mode={"radioSelect"}
                                                    data={listToTree(allCustomersObject, [bill.customerId])}
                                                    onChange={(value) => {
                                                        const newCustomerId = value.length == 1 ? value[0] : "";
                                                        changeBill("customerId", newCustomerId);
                                                    }}/>
                    </div>


                    {customerDiscountCodes.length > 0 && <div className="col-12 mb-4">
                        <label className="card-title mb-2">کد های تخفیف فعال کاربر</label>
                        <div role="group" className="btn-group btn-group-lg w-100 mb-4">
                            {
                                customerDiscountCodes.map((discountCode, index) => {
                                    return (
                                        <button key={index} type="button" onClick={() => {
                                            if (bill.discountCodeId) {
                                                changeBill("discountCodeId", "");
                                                return;
                                            }
                                            changeBill("discountCodeId", discountCode.id);
                                        }}
                                                className={`btn ${discountCode.id == bill.discountCodeId ? "btn-secondary text-white" : "btn-outline-secondary"} py-4`}>
                                            <h6 className={"mb-3"}>
                                                آیدی: {discountCode.id}
                                            </h6>
                                            <h4 className={"mb-3"}>
                                                {discountCode.code}
                                            </h4>
                                            <h6>
                                                {getDiscountCodeAmountDescription(discountCode)}
                                            </h6>
                                        </button>
                                    );
                                })
                            }
                        </div>
                    </div>}

                    <div className="col-12 mb-4">
                        <TreeSelectWithoutContainer label={"انتخاب آدرس مشتری"} mode={"radioSelect"}
                                                    data={listToTree(allCustomerAddresses, [bill.addressId])}
                                                    onChange={(value) => {
                                                        const newAddressId = value.length == 1 ? value[0] : "";
                                                        changeBill("addressId", newAddressId);
                                                    }}/>
                    </div>

                    <div className="col-md-4">
                        <TextInputWithoutContainer type={"number"} label={"هزینه ارسال فاکتور"}
                                                   value={bill.deliveryAmount}
                                                   onChange={(value) => {
                                                       changeBill("deliveryAmount", value);
                                                   }}/>
                    </div>

                    <div className="col-md-4">
                        <PickDateTimeWithoutContainer timestamp={bill.deliveryTimestamp} label={"زمان تحویل"}
                                                      onChange={(value) => {
                                                          changeBill("deliveryTimestamp", value);
                                                      }}/>
                    </div>
                    <div className="col-md-4">
                        <label className="card-title mb-3">وضعیت فاکتور</label>
                        <div className="form-input">
                            <input className="form-check-input" type="checkbox" checked={bill.isVerified}
                                   id="BillIsVerified"
                                   onChange={() => {
                                       changeBill("isVerified", !bill.isVerified);
                                   }}/>
                            <label className="form-check-label me-2" htmlFor="BillIsVerified">
                                فاکتور مورد تایید است.
                            </label>
                        </div>
                        <div className="form-input">
                            <input className="form-check-input" type="checkbox" checked={bill.isPayed}
                                   id="BillIsPayed"
                                   onChange={() => {
                                       changeBill("isPayed", !bill.isPayed);
                                   }}/>
                            <label className="form-check-label me-2" htmlFor="BillIsPayed">
                                وجه پرداخت شده است.
                            </label>
                        </div>
                    </div>

                    <hr className={"my-4"}/>

                    <div className="col-12 mb-4">
                        <TreeSelectWithoutContainer label={"انتخاب محصول"} mode={"radioSelect"}
                                                    data={listToTree(allProducts, [tempValues.productId])}
                                                    onChange={(value) => {
                                                        const newProductId = value.length == 1 ? value[0] : "";
                                                        changeTempValues("productId", newProductId);
                                                    }}/>
                    </div>
                    <div className="col-md-6">
                        <TreeSelectWithoutContainer label={"انتخاب  تک محصول"} mode={"radioSelect"}
                                                    data={listToTree(allSingleProducts, [tempValues.billItem.singleProductId])}
                                                    onChange={(value) => {
                                                        const newSingleProductId = value.length == 1 ? value[0] : "";
                                                        const newBillItem = {
                                                            ...tempValues.billItem,
                                                            singleProductId: newSingleProductId
                                                        };
                                                        changeTempValues("billItem", newBillItem);
                                                    }}/>
                    </div>
                    <div className="col-md-3">
                        <TextInputWithoutContainer id={"count"} type={"number"} label={"تعداد"} classname={"mb-3"}
                                                   value={tempValues.billItem.count}
                                                   onChange={(value) => {
                                                       const newBillItem = {...tempValues.billItem, count: value};
                                                       changeTempValues("billItem", newBillItem);
                                                   }}/>
                    </div>
                    <div className="col-md-3">
                        <SelectWithoutContainer label={"نوع پرداخت"} options={payTypeOptions}
                                                value={tempValues.billItem.payType}
                                                onChange={(value) => {
                                                    const newBillItem = {...tempValues.billItem, payType: value};

                                                    changeTempValues("billItem", newBillItem);
                                                }}/>
                    </div>
                    {tempValues.billItem.singleProductId && tempValues.billItem.payType == "INSTALLMENT" && <div>
                        <label className="card-title mb-2 mt-4">اقساط</label>
                        <div className="d-inline-block form-switch me-4">
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked">نمایش اقساط تعریف
                                شده</label>
                            <input className="form-check-input me-2" type="checkbox" role="switch"
                                   id="flexSwitchCheckChecked"
                                   checked={tempValues.showDefinedInstallment} onChange={() => {
                                changeTempValues("showDefinedInstallment", !tempValues.showDefinedInstallment)
                            }}/>
                        </div>

                        {tempValues.showDefinedInstallment && <div className="col-12 mt-3">
                            <div role="group" className="btn-group btn-group-lg w-100 mb-4">
                                {
                                    userLevels.map((userLevel, index) => {
                                        return (
                                            <button key={index} type="button"
                                                    className={`btn btn-outline-secondary py-4`}>
                                                <h6>اقساط کاربری {userLevel.persianLabel}</h6>
                                                <hr/>
                                                {printInstallmentConditions(singleProductPrices[`${userLevel.englishLabel}Installment`])}

                                            </button>

                                        );
                                    })
                                }
                            </div>
                        </div>}

                        <div className={"row"}>
                            <div className="col-md-4 mt-4">
                                <TextInputWithoutContainer id={"prepayedAmount"} type={"number"}
                                                           label={"مبلغ پیش پرداخت"}
                                                           classname={"mb-3"} value={tempValues.billItem.prepayedAmount}
                                                           onChange={(value) => {
                                                               const newBillItem = {
                                                                   ...tempValues.billItem,
                                                                   prepayedAmount: value
                                                               };
                                                               changeTempValues("billItem", newBillItem);
                                                           }}/>
                            </div>

                            <div className="col-md-2 mt-4">
                                <TextInputWithoutContainer id={"numberOfInstallment"} type={"number"}
                                                           label={"تعداد اقساط"}
                                                           classname={"mb-3"}
                                                           value={tempValues.billItem.numberOfInstallment}
                                                           onChange={(value) => {
                                                               const newInstallmentHistories = getInstallmentHistory(value, tempValues.billItem.refundMethod);
                                                               const newBillItem = {
                                                                   ...tempValues.billItem,
                                                                   installmentHistories: newInstallmentHistories,
                                                                   numberOfInstallment: value
                                                               };
                                                               changeTempValues("billItem", newBillItem);
                                                           }}/>
                            </div>

                            <div className="col-md-3 mt-4">
                                <SelectWithoutContainer label={"نحوه بازپرداخت"}
                                                        options={refundMethodOptions}
                                                        value={tempValues.billItem.refundMethod}
                                                        onChange={(value) => {
                                                            console.log(value);
                                                            const newInstallmentHistories = getInstallmentHistory(tempValues.billItem.numberOfInstallment || 1, value);
                                                            const newBillItem = {
                                                                ...tempValues.billItem,
                                                                installmentHistories: newInstallmentHistories,
                                                                refundMethod: value
                                                            };
                                                            changeTempValues("billItem", newBillItem);
                                                        }}/>
                            </div>

                            {tempValues.billItem.installmentHistories.length > 0 && <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table text-center">
                                        <thead>
                                        <tr>
                                            <th width={"5%"}></th>
                                            <th width={"5%"}>آیدی</th>
                                            <th width={"5%"}>مبلغ</th>
                                            <th width={"15%"}>موعد قسط</th>
                                            <th width={"15%"}>زمان دریافت</th>
                                            <th width={"15%"}>وضعیت</th>
                                            <th width={"25%"}>توضیح</th>
                                            <th>توضیح داخلی</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {tempValues.billItem.installmentHistories.map((installmentHistory, index) => {
                                            return (
                                                <tr key={index} className={"align-items-center"}>
                                                    <td>{index + 1}</td>
                                                    <td>{installmentHistory.id || ""}</td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={installmentHistory.amount}
                                                                                   onChange={(value) => {
                                                                                       const newInstallmentHistories = [...tempValues.billItem.installmentHistories];
                                                                                       newInstallmentHistories[index].amount = value;
                                                                                       const newBillItem = {
                                                                                           ...tempValues.billItem,
                                                                                           installmentHistories: newInstallmentHistories,
                                                                                       };
                                                                                       changeTempValues("billItem", newBillItem);
                                                                                   }}/>
                                                    </td>
                                                    <td>
                                                        <PickDateTimeWithoutContainer
                                                            timestamp={installmentHistory.paymentTimestamp}
                                                            onChange={(value) => {
                                                                const newInstallmentHistory = [...tempValues.billItem.installmentHistories];
                                                                newInstallmentHistory[index].paymentTimestamp = value;
                                                                const newBillItem = {
                                                                    ...tempValues.billItem,
                                                                    installmentHistory: newInstallmentHistory,
                                                                };
                                                                changeTempValues("billItem", newBillItem);
                                                            }}/>
                                                    </td>

                                                    <td>
                                                        {installmentHistory.status == "PAYED" &&
                                                            <PickDateTimeWithoutContainer
                                                                timestamp={installmentHistory.payedTimestamp}
                                                                onChange={(value) => {
                                                                    const newInstallmentHistories = [...tempValues.billItem.installmentHistories];
                                                                    newInstallmentHistories[index].payedTimestamp = value;
                                                                    const newBillItem = {
                                                                        ...tempValues.billItem,
                                                                        installmentHistories: newInstallmentHistories,
                                                                    };
                                                                    changeTempValues("billItem", newBillItem);
                                                                }}/>
                                                        }
                                                    </td>

                                                    <td>
                                                        <SelectWithoutContainer classname={"mb-0 mt-3"}
                                                                                options={statusOptions}
                                                                                value={installmentHistory.status}
                                                                                onChange={(value) => {
                                                                                    const newInstallmentHistories = [...tempValues.billItem.installmentHistories];
                                                                                    newInstallmentHistories[index].status = value;
                                                                                    const newBillItem = {
                                                                                        ...tempValues.billItem,
                                                                                        installmentHistories: newInstallmentHistories,
                                                                                    };
                                                                                    changeTempValues("billItem", newBillItem);
                                                                                }}/>
                                                    </td>

                                                    <td>
                                                        <TextInputWithoutContainer
                                                            value={installmentHistory.description}
                                                            onChange={(value) => {
                                                                const newInstallmentHistories = [...tempValues.billItem.installmentHistories];
                                                                newInstallmentHistories[index].description = value;
                                                                const newBillItem = {
                                                                    ...tempValues.billItem,
                                                                    installmentHistories: newInstallmentHistories,
                                                                };
                                                                changeTempValues("billItem", newBillItem);
                                                            }}/>
                                                    </td>
                                                    <td>
                                                        <TextInputWithoutContainer
                                                            value={installmentHistory.privateDescription}
                                                            onChange={(value) => {
                                                                const newInstallmentHistories = [...tempValues.billItem.installmentHistories];
                                                                newInstallmentHistories[index].privateDescription = value;
                                                                const newBillItem = {
                                                                    ...tempValues.billItem,
                                                                    installmentHistories: newInstallmentHistories,
                                                                };
                                                                changeTempValues("billItem", newBillItem);
                                                            }}/>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>}


                        </div>

                    </div>}

                    {tempValues.billItem.singleProductId && tempValues.billItem.payType == "CASH" && <Fragment>
                        <div className="col-12 mt-3">
                            <label className="card-title mb-2">قیمت گذاری</label>
                            <div className="d-inline-block form-switch me-4">
                                <label className="form-check-label" htmlFor="flexSwitchCheckChecked">قیمت دستی</label>
                                <input className="form-check-input me-2" type="checkbox" role="switch"
                                       id="flexSwitchCheckChecked"
                                       checked={tempValues.manualPrice} onChange={() => {
                                    changeTempValues("manualPrice", !tempValues.manualPrice)
                                }}/>
                            </div>
                        </div>

                        {!tempValues.manualPrice && Object.keys(singleProductPrices).length > 0 &&
                            <div className="col-12 mt-3">
                                <div role="group" className="btn-group btn-group-lg w-100 mb-4">
                                    {
                                        userLevels.map((userLevel, index) => {
                                            return (
                                                <button key={index} type="button" onClick={() => {
                                                    if (!singleProductPrices[`${userLevel.englishLabel}Price`].id || !singleProductPrices[`${userLevel.englishLabel}Price`].amount)
                                                        return;
                                                    const currency = singleProductPrices.currency;
                                                    const newBillItem = {
                                                        ...tempValues.billItem,
                                                        priceId: singleProductPrices[`${userLevel.englishLabel}Price`].id,
                                                        price: {
                                                            ...singleProductPrices[`${userLevel.englishLabel}Price`],
                                                            currency: currency
                                                        }
                                                    };
                                                    changeTempValues("billItem", newBillItem);
                                                }}
                                                        className={`btn ${singleProductPrices[`${userLevel.englishLabel}Price`].id == tempValues.billItem.priceId ? "btn-secondary" : "btn-outline-secondary"} py-4`}>
                                                    <h6>قیمت کاربری {userLevel.persianLabel}</h6>
                                                    <hr/>
                                                    {singleProductPrices[`${userLevel.englishLabel}Price`].amount &&
                                                        <Fragment>
                                                    <span
                                                        className={singleProductPrices[`${userLevel.englishLabel}Price`].discountAmount ? "text-decoration-line-through" : ""}>{singleProductPrices[`${userLevel.englishLabel}Price`].amount}</span>
                                                            <br/>
                                                            {singleProductPrices[`${userLevel.englishLabel}Price`].discountAmount &&
                                                                <span>{singleProductPrices[`${userLevel.englishLabel}Price`].discountAmount}</span>}
                                                            <br/>
                                                            <span>{singleProductPrices.currency.name}</span>
                                                            <br/>
                                                            <span>نرخ: {singleProductPrices.currency.rate.toLocaleString()}</span>
                                                        </Fragment>
                                                    }
                                                    {!singleProductPrices[`${userLevel.englishLabel}Price`].amount &&
                                                        <Fragment>
                                                    <span className={"text-danger"}>
                                                        قیمت تعریف نشده
                                                    </span>
                                                        </Fragment>
                                                    }

                                                </button>

                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }

                        {tempValues.billItem.singleProductId && tempValues.manualPrice && <div>

                            <div role="group" className="btn-group btn-group-lg ltr w-100 mt-4">
                                {
                                    allCurrencyObject.map((currency, index) => {
                                        return (
                                            <button onClick={() => {
                                                const newPrice = {
                                                    ...tempValues.billItem.price,
                                                    currency: {...currency}
                                                };
                                                const newBillItem = {
                                                    ...tempValues.billItem,
                                                    price: newPrice
                                                };
                                                changeTempValues("billItem", newBillItem);
                                            }} key={index} type="button"
                                                    className={`btn ${tempValues.billItem.price.currency.id == currency.id ? 'btn-primary' : 'btn-outline-primary'}`}>
                                                <span>{currency.name}</span>
                                                <br/>
                                                <span>نرخ: {currency.rate.toLocaleString()}</span>
                                            </button>
                                        );
                                    })
                                }
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-4">
                                    <TextInputWithoutContainer label={"قیمت"} type={"number"}
                                                               value={tempValues.billItem.price.amount}
                                                               onChange={(value) => {
                                                                   const discountPercent = value && tempValues.billItem.price.discountAmount ? 100 - Math.floor(tempValues.billItem.price.discountAmount / value * 100) : "";
                                                                   const newPrice = {
                                                                       ...tempValues.billItem.price,
                                                                       amount: value,
                                                                       discountPercent: discountPercent
                                                                   };
                                                                   const newBillItem = {
                                                                       ...tempValues.billItem,
                                                                       price: newPrice
                                                                   };
                                                                   changeTempValues("billItem", newBillItem);
                                                               }}/>
                                </div>
                                <div className="col-md-4">
                                    <TextInputWithoutContainer label={"قیمت با تخفیف"} type={"number"}
                                                               value={tempValues.billItem.price.discountAmount}
                                                               onChange={(value) => {
                                                                   const discountPercent = value && tempValues.billItem.price.amount ? 100 - Math.floor(value / tempValues.billItem.price.amount * 100) : "";
                                                                   const newPrice = {
                                                                       ...tempValues.billItem.price,
                                                                       discountAmount: value,
                                                                       discountPercent: discountPercent
                                                                   };
                                                                   const newBillItem = {
                                                                       ...tempValues.billItem,
                                                                       price: newPrice
                                                                   };
                                                                   changeTempValues("billItem", newBillItem);
                                                               }}/>
                                </div>
                                <div className="col-md-2">
                                    <TextInputWithoutContainer label={"درصد تخفیف"} disabled={true} type={"number"}
                                                               value={tempValues.billItem.price.discountPercent}
                                    />
                                </div>
                            </div>
                        </div>
                        }

                    </Fragment>}
                    <div className="col-12 mt-2">
                        <div className="form-input">
                            <input className="form-check-input" type="checkbox" checked={tempValues.billItem.isPayed}
                                   id="isPayed"
                                   onChange={() => {
                                       const newTempValues = {
                                           ...tempValues.billItem,
                                           isPayed: !tempValues.billItem.isPayed
                                       };
                                       changeTempValues("billItem", newTempValues);
                                   }}/>
                            <label className="form-check-label me-2" htmlFor="isPayed">
                                وجه پرداخت شده است.
                            </label>
                        </div>
                    </div>
                    <div className="col-12 mt-2">
                        <div className="form-input">
                            <input className="form-check-input" type="checkbox"
                                   checked={tempValues.billItem.isDelivered}
                                   id="isDelivered"
                                   onChange={() => {
                                       const newTempValues = {
                                           ...tempValues.billItem,
                                           isDelivered: !tempValues.billItem.isDelivered
                                       };
                                       changeTempValues("billItem", newTempValues);
                                   }}/>
                            <label className="form-check-label me-2" htmlFor="isDelivered">
                                کالا تحویل داده شده است.
                            </label>
                        </div>
                    </div>
                    <div className="col-12 mb-5">
                        <button disabled={!tempValues.billItem.singleProductId || !tempValues.billItem.count}
                                className={"btn btn-success w-100 mt-3"} onClick={async () => {
                            const persianTitle = await getSingleProductPersianTitleById(tempValues.billItem.singleProductId)
                            const newBill = {
                                ...bill,
                                billItems: [...bill.billItems, {...tempValues.billItem, persianTitle}]
                            }

                            onChange(newBill);
                        }}>افزودن
                        </button>
                    </div>

                    <hr className="my-5"/>

                    <div className="table-responsive mt-5">
                        <table className={"table text-center"}>
                            <thead>
                            <tr>
                                <th width={"5%"}>#</th>
                                <th>نام محصول</th>
                                <th>قیمت واحد</th>
                                <th>ارز (نرخ)</th>
                                <th width={"5%"}>تعداد</th>
                                <th>قیمت کل</th>
                                <th>نحوه پرداخت</th>
                                <th>وضعیت پرداخت</th>
                                <th>وضعیت تحویل</th>
                                <th width={"5%"}></th>
                            </tr>
                            </thead>

                            <tbody>
                            {bill.billItems.map((billItem, index) => {

                                return (<tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className={"text-right"}>{billItem.persianTitle}</td>
                                    <td>
                                        {
                                            printUnitPriceForBill(billItem.price)
                                        }
                                    </td>
                                    <td>{`${billItem.price.currency.name} (${billItem.price.currency.rate})`}</td>
                                    <td>{billItem.count}</td>
                                    <td>{(getUnitPrice(billItem.price) * billItem.count).toLocaleString()}</td>
                                    <td>
                                        {billItem.payType == "CASH" && <span className={"text-primary"}>نقدی</span>}
                                        {billItem.payType == "INSTALLMENT" &&
                                            <span className={"text-warning"}>قسطی</span>}
                                    </td>

                                    <td>
                                        {billItem.isPayed && <span className={"text-success"}>پرداخت شده</span>}
                                        {!billItem.isPayed && <span className={"text-danger"}>پرداخت نشده</span>}
                                        <button className={"btn btn-sm btn-secondary d-block mt-2 mx-auto"} onClick={() => {
                                            const newBillItems = [...bill.billItems];
                                            newBillItems[index].isPayed = !newBillItems[index].isPayed;
                                            changeBill("billItems", newBillItems)
                                        }}>تغییر
                                            وضعیت
                                        </button>
                                    </td>

                                    <td>
                                        <SelectWithoutContainer options={deliveryOptions}  value={billItem.deliveryStatus || "WAITING"} onChange={(value) => {
                                            const newBillItems = [...bill.billItems] ;
                                            newBillItems[index].deliveryStatus = value ;
                                            changeBill("billItems", newBillItems)
                                        }} />
                                    </td>


                                    <td>
                                        <button className={"btn btn-danger"} onClick={() => {
                                            const newBillItems = bill.billItems.filter((b, i) => {
                                                if (index != i)
                                                    return b;

                                            });
                                            changeBill("billItems", newBillItems)
                                        }}>
                                            <FontAwesomeIcon icon={faTrash}/>
                                        </button>
                                    </td>
                                </tr>);
                            })}
                            </tbody>
                        </table>
                        <div className="col-md-4 col-sm-6 me-auto mt-4">
                            <table className={"table table-borderless table-hover text-center"}>
                                <tbody>
                                <tr>
                                    <td className={"w-50"}>مبلغ کل فاکتور</td>
                                    <td className={"w-50"}>{getBillAmountWithoutDiscount(bill.billItems).toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <td className={"w-50"}>هزینه ارسال</td>
                                    <td className={"w-50"}>{bill.deliveryAmount ? parseInt(bill.deliveryAmount).toLocaleString() : <span className={"text-danger"}>رایگان</span>}</td>
                                </tr>
                                <tr>
                                    <td className={"w-50"}>تخفیف روی فاکتور</td>
                                    <td className={"w-50"}>{getBillDiscountAmount(bill.billItems).toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <td className={"w-50"}>تخفیف با کد تخفیف</td>
                                    <td className={"w-50"}>
                                        {bill.discountAmountWithDiscountCode ? bill.discountAmountWithDiscountCode.toLocaleString() : ""}
                                    </td>
                                </tr>

                                <tr>
                                    <td className={"w-50"}>قابل پرداخت</td>
                                    <td className={"w-50"}>{getBillPayableAmount(bill).toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <td className={"w-50"}>وصول شده</td>
                                    <td className={"w-50"}>
                                        {
                                            getBillPayedAmount(bill).toLocaleString()
                                        }
                                    </td>
                                </tr>
                                <tr className={"bg-warning"}>
                                    <td className={"w-50"}>باقی مانده</td>
                                    <td className={"w-50"}>
                                        {
                                            (getBillPayableAmount(bill) - getBillPayedAmount(bill)).toLocaleString()
                                        }
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderForm;